import {Button} from '@material-ui/core';
import CoreRouteConstants from 'Core/CoreRouteConstants';
import React from 'react';
import {Link} from 'react-router-dom';

const PasswordResetSuccessful = () => {
  return (
    <div className="password-reset-succesful">
      <h1>Password Reset Successful</h1>
      <p>Your reset request was successful.</p>
      <p>Please return to the login page and use your new credentials.</p>
      <Link to={CoreRouteConstants.LOGIN}>
        <Button variant="contained" color="primary">
          Return to Login
        </Button>
      </Link>
    </div>
  );
};

export default PasswordResetSuccessful;
